<div class="preview-dialog-overlay" [ngClass]="'theme-' + data.themeId">

  <!-- 1. Promo Centered -->
  <div *ngIf="data.templateId === 'promo-centered'" class="popup animate__animated animate__zoomIn">
    <img *ngIf="data.image?.url" [src]="data.image.url" alt="Promo">
    <div class="popup-content">
      <div class="popup-title text-center">{{ data.title }}</div>
      <div class="popup-body">{{ data.body }}</div>
      <div class="popup-footer">
        <button class="popup-primary" (click)="onPrimaryAction()">{{ data.primaryAction?.label || 'Voir l\'offre' }}</button>
        <button class="popup-secondary" (click)="close()">{{ data.secondaryAction?.label || 'Later' }}</button>
      </div>
    </div>
  </div>

  <div *ngIf="data.templateId === 'minimal-toast'" class="toast animate__animated animate__slideInRight">
    <div class="toast-title">{{ data.title }}</div>
    <div class="toast-body">{{ data.body }}</div>
    <div class="toast-actions">
      <button class="toast-secondary" (click)="close()">Fermer</button>
      <button class="toast-primary" (click)="onPrimaryAction()">{{ data.primaryAction?.label || 'Voir l\'offre' }}</button>
    </div>
  </div>

  <!-- 3.
   Fullscreen -->
  <div *ngIf="data.templateId === 'hero-fullscreen'" class="hero-overlay animate__animated animate__zoomIn">
    <div *ngIf="data.image?.url" class="hero-image" [style.backgroundImage]="'url(' + data.image.url + ')'"></div>
    <div class="hero-content">
      <div class="hero-title text-center">{{ data.title }}</div>
      <div class="hero-body">{{ data.body }}</div>
      <button class="hero-primary" (click)="onPrimaryAction()">{{ data.primaryAction?.label || 'Voir l\'offre' }}</button>
      <button class="hero-secondary" (click)="close()">Non merci, plus tard</button>
    </div>
  </div>

</div>
